import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Grid, Button, Popover, Typography } from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';

import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red"
  },
  disabled: {
    background: '#f5f2f2'
  },

  textInput: {
    '& input::placeholder': {
      color: '#808080',
      opacity: 1,
      borderColor: "#EF7000"
    }
  },
  infoIcon: {
    color: 'rgb(7,121,131)'
  }
}));


export const Input = (props: any) => {

  const classes = useStyles();
  const {
    // label,
    type,
    name,
    placeholder,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    infoIcon,
    infoMessage,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    multiline,
    index,
    handleChange,
    hoverText,
    isDynamicField,
  } = props.componentObject;

  return (
    <form autoComplete="off">
      <TextField
        className={classes.textInput}
        classes={classNames}
        id="outlined-basic"
        name={name}
        placeholder={placeholder}
        variant="outlined"
        required={required ? required : false}
        disabled={disabled}
        error={helperText ? true : false}
        type={type}
        size="small"
        defaultValue={defaultValue}
        // helperText={helperText}
        InputLabelProps={{
          shrink: true,
          style: { fontSize: "16px", fontFamily: "Open Sans", padding: "0px" },
        }}
        FormHelperTextProps={{
          className: classes.helperText
        }}
        InputProps={{
          readOnly: readOnly ? readOnly : false,
          classes: {
            disabled: classes.disabled,
          },
          title: hoverText && hoverText,
          inputProps: {
            min: 0
          },
          style: { fontSize: "16px", fontFamily: "Open Sans", padding: "0px" },
        }}
        autoFocus={autoFocus}
        multiline={multiline}
        rows={4}
        //   onChange={() => handleChange()}
        rowsMax={rowsMax}
        color={color}
        fullWidth
        value={value !=="null"?value:""}
        onChange={(e) => handleChange(e.target.value, index, '', isDynamicField)}
        onKeyPress={(e) => { ((e.key === 'Enter' && !multiline) || (e.key === '-')) && e.preventDefault(); }}
        inputProps={{
          autocomplete: name,
          form: {
            autocomplete: 'off',
          },
        }}
      />
      <span style={{ color: "#f44336", fontSize: '0.75rem', marginRight: '14px' }}> {helperText}</span></form>
  );
};

export default function InputComponent(props: any) {
  const classes = useStyles();
  const { label, infoIcon, infoMessage, hideLabel } = props.componentObject;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (

    <Grid container className={classes.gridRoot}>

      {!hideLabel ? <Grid item xs={12} md={infoIcon === "yes" ? 3 : 4}>
        {label}
      </Grid> : null}
      {infoIcon === "yes" && <Grid item xs={12} md={1}>
        <div>

          <IconButton
            aria-describedby={id}
            className={classes.infoIcon}
            // style={{color:"#EF7000"}}
            onClick={handleClick}
          >
            <InfoIcon />
          </IconButton>
          <Popover
            id={id}
            style={{ width: '61%' }}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Typography variant="h2" style={{ padding: '20px' }} >{infoMessage}</Typography>
          </Popover>
        </div>
      </Grid>}
      {/* <div style={{ width: "70%" }}> */}
      <Grid item xs={12} md={!hideLabel ? 7 : 12}>
        <Input componentObject={props.componentObject} />
      </Grid>

    </Grid>
    // </form>
  );
}
